import ServiceTemplate from '../ServiceTemplate';

const ReverseMortgage = () => {
  const serviceData = {
    title: 'משכנתא הפוכה',
    description: 'פתרון ייחודי לבני הגיל השלישי המאפשר לקבל הכנסה חודשית קבועה מהנכס שבבעלותכם, תוך המשך מגורים בבית ושמירה על הזכויות בנכס.',
    sections: [
      {
        title: 'מהי משכנתא הפוכה?',
        content: 'משכנתא הפוכה היא הלוואה המאפשרת לבעלי נכס מעל גיל 60 לקבל הכנסה חודשית קבועה או סכום חד פעמי מהבנק, כנגד שעבוד הנכס שבבעלותם. בניגוד למשכנתא רגילה, אין צורך בהחזרים חודשיים, והסכום המלא מוחזר רק בתום תקופת ההלוואה או במכירת הנכס.'
      },
      {
        title: 'איך התהליך עובד?',
        content: 'נתחיל בפגישת ייעוץ בה נבחן את שווי הנכס, גילכם, והצרכים הכלכליים שלכם. נחשב את גובה ההכנסה החודשית האפשרית, נסביר את כל התנאים והמשמעויות, ונלווה אתכם בתהליך מול הבנק עד לקבלת ההכנסה החודשית הראשונה.'
      }
    ],
    benefits: [
      'הכנסה חודשית קבועה לכל החיים',
      'המשך מגורים בנכס ללא שינוי',
      'אין צורך בהחזרים חודשיים',
      'שמירה על זכויות הבעלות בנכס',
      'גמישות בבחירת מסלול קבלת הכספים',
      'ביטחון כלכלי לגיל השלישי'
    ],
    faqs: [
      {
        question: 'מי זכאי למשכנתא הפוכה?',
        answer: 'משכנתא הפוכה מיועדת לבעלי נכס מעל גיל 60, כאשר הנכס בבעלותם המלאה או שיש עליו משכנתא בסכום נמוך יחסית. הזכאות והתנאים המדויקים נקבעים על פי גיל הלווים, שווי הנכס ומיקומו.'
      },
      {
        question: 'האם ניתן להוריש את הנכס?',
        answer: 'כן, בהחלט. היורשים יכולים לבחור בין מספר אפשרויות: לפרוע את ההלוואה ולקבל את הנכס, למכור את הנכס ולקבל את ההפרש שנותר לאחר פירעון ההלוואה, או לקבל משכנתא חדשה לצורך פירעון ההלוואה.'
      },
      {
        question: 'מה קורה אם שווי הנכס יורד?',
        answer: 'במשכנתא הפוכה קיימת הגנה מיוחדת - גם אם שווי הנכס יורד, אתם או היורשים שלכם לא תידרשו להשלים את ההפרש. הסיכון במקרה כזה הוא על הבנק.'
      },
      {
        question: 'האם אפשר לבטל את המשכנתא ההפוכה?',
        answer: 'כן, ניתן לסיים את ההסכם בכל עת על ידי החזרת הסכום שנצבר עד לאותו מועד. אין קנסות מיוחדים על פירעון מוקדם במשכנתא הפוכה.'
      },
      {
        question: 'האם חייבים לקחת הכנסה חודשית קבועה?',
        answer: 'לא, קיימים מספר מסלולים: הכנסה חודשית קבועה, משיכה חד פעמית של סכום גדול, שילוב של השניים, או קו אשראי שניתן לנצל לפי הצורך. נעזור לכם לבחור את המסלול המתאים ביותר עבורכם.'
      }
    ],
    whatsappMessage: 'שלום, אני מתעניין/ת במשכנתא הפוכה ואשמח לקבל מידע נוסף.'
  };

  return <ServiceTemplate {...serviceData} />;
};

export default ReverseMortgage; 